$(document).ready(function () {
  $('.seulskin-tabs .button').on('click', function () {
    let tabId = $(this).data("seultab");
    $('.seulskin-categories .active').removeClass("active");
    $('[data-seultab=' + tabId + ']').addClass("active");
  });
});

//slider producentów
var swiperSeulBrands = new Swiper(".seulskin-brands-list.swiper", {
  effect: 'slide',
  speed: 500,
  loop: false,
  slidesPerView: 2,
  spaceBetween: 32,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
  navigation: {
    nextEl: '.seulskin-brands .swiper-next',
    prevEl: '.seulskin-brands .swiper-prev',
  },
  pagination: {
    el: '.seulskin-brands .swiper-pagination',
    clickable: true
  },
  breakpoints: {
    992: {
      slidesPerView: 4
    }
  }
});

var swiperSeulBrands = new Swiper(".seulskin-steps-list.swiper", {
  effect: 'slide',
  speed: 500,
  loop: false,
  slidesPerView: 2,
  spaceBetween: 32,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
  navigation: {
    nextEl: '.seulskin-steps .swiper-next',
    prevEl: '.seulskin-steps .swiper-prev',
  },
  pagination: {
    el: '.seulskin-steps .swiper-pagination',
    clickable: true
  },
  breakpoints: {
    576: {
      slidesPerView: 3
    },
    768: {
      slidesPerView: 4
    },
    992: {
      slidesPerView: 5
    }
  }
});


var swiperSeulSkladnikiSmall = new Swiper(".seul_skladniki-list.swiper", {
  effect: 'slide',
  speed: 500,
  slidesPerView: 'auto',
  slideToClickedSlide: true,
  loop: false
});

var swiperSeulSkladnikiBig = new Swiper(".seul_skladniki-big.swiper", {
  effect: 'fade',
  speed: 500,
  slidesPerView: 1,
  allowTouchMove: false,
  loop: false,
  thumbs: {
    swiper: swiperSeulSkladnikiSmall,
  },
  navigation: {
    nextEl: '.seul_skladniki .swiper-next',
    prevEl: '.seul_skladniki .swiper-prev',
  },
  pagination: {
    el: '.seul_skladniki .swiper-pagination',
    clickable: true
  }
});
document.addEventListener('DOMContentLoaded', function (event) {
  setTimeout(function () {
    var seulInsta = document.querySelector('.instafeed-new-layout-container');
    seulInsta.classList.add('swiper');
    var swiperSeulInsta = new Swiper(".seulskin-main .instafeed-new-layout-container.swiper", {
      effect: 'slide',
      speed: 500,
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      slideClass: "instafeed-new-layout-item",
      wrapperClass: "instafeed-new-layout-wrapper",
      containerClass: 'instafeed-new-layout-container',
      navigation: {
        nextEl: '.shopify-app-block .swiper-next',
        prevEl: '.shopify-app-block .swiper-prev',
      },
      pagination: {
        el: '.shopify-app-block .swiper-pagination',
        clickable: true
      },
      breakpoints: {
        576: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 3
        }
      }
    });
  }, 1500);
});